import { FC, ReactElement } from "react";
import Tooltip from "../Tooltip";
import {BsFillInfoCircleFill} from "react-icons/bs";
import {useGetDevourLootboxNftRewards} from "@/hooks/useGetDevourLootboxNftReward";
import { NftRewardPrize } from "@devour/client";

interface Props {
    nftTrackerId: string;
}

export const GoVipRewardsNftTooltip: FC<Props> = (props: Props): ReactElement => {
    const {data: reward} = useGetDevourLootboxNftRewards(props.nftTrackerId);

    const outsideContent: ReactElement =
        <div className="govip-rewards-drawer_reward_tooltip_label">
            <BsFillInfoCircleFill/>
        </div>;

    function renderPrizeRow(prize: NftRewardPrize) {
        const remainingQuantity = prize.quantity - prize.wonQuantity;
        if (!remainingQuantity) {
            return null;
        }
        return (
            <div
                className="govip-rewards-drawer_reward_tooltip_prizes_row"
                key={prize.id}
            >
                <span className="govip-rewards-drawer_reward_tooltip_prizes_row_name">
                    {prize.rewardConfig.name}
                </span>
                <span className="govip-rewards-drawer_reward_tooltip_prizes_row_quantity">
                    {remainingQuantity}
                </span>
            </div>
        );
    }

    return (
        <Tooltip
            containerElementClassname="govip-rewards-drawer_reward"
            outsideContent={outsideContent}
            className="govip-rewards-drawer_reward_tooltip"
        >
            <div className="govip-rewards-drawer_reward_tooltip_header">
                <BsFillInfoCircleFill/>
                What's Inside the Loot Box?
            </div>

            <div className="govip-rewards-drawer_reward_tooltip_info">
                Each prize in our collection is accompanied by a specified quantity limit.
                A prize will be randomly selected from below.
            </div>

            <div className="govip-rewards-drawer_reward_tooltip_prizes">
                <div className="govip-rewards-drawer_reward_tooltip_prizes_row row-header">
                    <span>Prize</span>
                    <span>Quantity</span>
                </div>
                <hr />
                {reward?.prizes?.map(renderPrizeRow)}
            </div>
        </Tooltip>
    );
};
